// PayableDetail.service.ts

import PayableDetailApi from "../api/PayableDetail.api";

const PayableDetailService = {
  /**
   * 📌 Obtener detalle de Cuenta por Pagar
   * GET /api/payables/details/{id}
   */
  getById: async (id: number) => {
    const response = await PayableDetailApi.fetchCustom(`/${id}`);

    return response.data;
  },
};

export default PayableDetailService;